//import { Connector } from 'mqtt-react-hooks';
import Pastdata from "./pastdata.js"
import Healthmonitoring from "./healthmonitoring.js"
import Realtimemonitor from "./realtimemonitor.js"
import styles from './css/site.module.css' 

export default function Site(props) {

  return (
    <div className={styles.modal_body}>
      <div className={styles.modal_header}>
        <div className={styles.title}>{props.point.name}</div>
        <div className={styles.discription}>風速:過去1分間の平均・雨量:過去1時間の合計・震度:過去24時間の最大の震度</div>
      </div>
      <div className={styles.modal_content}>
        <div className={styles.tabs}>
          <input id="now" type="radio" name="tab_item" defaultChecked />
          <label className={styles.tab_item} htmlFor="now">現在の状況</label>
          <input id="past" type="radio" name="tab_item" />
          <label className={styles.tab_item} htmlFor="past">過去のデータ</label>
          <input id="damage" type="radio" name="tab_item" />
          <label className={styles.tab_item} htmlFor="damage">被災度判定</label>
          <div className={styles.tab_content} id="now_content">
            <Realtimemonitor point={props.point}/>
          </div>
          <div className={styles.tab_content} id="past_content">
            <Pastdata point={props.point} />
          </div>
          <div className={styles.tab_content} id="damage_content">
            <Healthmonitoring point={props.point} admin={props.admin}/>
          </div>
        </div>
      </div>
    </div>
  )
};